import {sample as _sample} from 'lodash';

import {addContactConstants} from '../../../../../../../util/uiconstants';

//TODO: remove this mock data function
const randomEntities = () => {
	return _sample([
		[],
		[
			{description: 'Sample entity'},
			{description: 'Custom entity'},
			{description: 'New entity'},
			{description: 'Test long long long long long long name'},
			{description: 'Value name'}
		],
		[
			{description: 'Other entity'},
			{description: 'Best entity'},
			{description: 'Test long long long long long long name'},
			{description: 'Sample value'}
		],
		[{description: 'Sample entity'}, {description: 'Other entity'}, {description: 'New entity'}],
		[
			{description: 'A New entity'},
			{description: 'Test long long long long long long name'},
			{description: 'Sample value'}
		],
		[{description: 'Test long long long long long long name'}]
	]);
};

//TODO: remove this mock data function
const randomDashboard = () => {
	return _sample([
		[],
		['view', 'view', 'view', 'view', 'view'],
		['view', 'view', 'view', 'view'],
		['view', 'view', 'view'],
		['view', 'view'],
		['view']
	]);
};

//TODO: remove this mock data function
const randomContactList = (userType) => {
	if (userType === addContactConstants.member) {
		return _sample([true, false]);
	}
};

const toTitleCase = (text) => {
	return text
		.toLowerCase()
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
};

export const getUserWithProps = ({allProps: user}) => {
	const {gui, firstName, lastName, email, userType, engagements, serviceLineName, roleId, serviceLineId, roleName} = user;
	const entities = randomEntities();
	const dashboard = randomDashboard();
	const hasAccess = randomContactList(userType);

	return {
		emailAddress: email.toLowerCase(),
		name: toTitleCase(firstName),
		lastName: toTitleCase(lastName),
		userId: userType !== addContactConstants.member ? email : gui,
		isInternal: userType === addContactConstants.member,
		entities: entities,
		dashboardViews: dashboard,
		contactList: false,
		roleId,
		serviceLineName,
		serviceLineId,
		roleName,
		hasAccess: hasAccess,
		engagements
	};
};
